import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2 } from "lucide-react";
import AWLogo from "@/components/AWLogo";
import { waLink, WA_DISPLAY, WhatsAppIcon } from "@/lib/whatsapp";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-black text-white">
      <img
        src="/aw-logo.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-10 right-0 w-[34rem] max-w-[80vw] select-none opacity-[0.05] invert"
      />
      <div className="relative mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <AWLogo size={44} invert />
              <div className="leading-none">
                <div className="font-display text-xl font-extrabold tracking-tight">AUTOWORLD</div>
                <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-neutral-400">
                  Honda · Proton · Jaecoo &amp; Omoda
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">
              No agent. No markup. Honda, Proton, and Jaecoo &amp; Omoda.
              Best price, guaranteed.
            </p>
            <div className="mt-6 flex gap-3" data-testid="footer-socials">
              {[
                { icon: Instagram, label: "Instagram", href: "https://instagram.com/autoworld_aw" },
                { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/people/AutoWorld/61555857412689/" },
                { icon: Music2, label: "TikTok", href: "https://tiktok.com/@autoworld_aw" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`social-${s.label.toLowerCase()}`}
                  aria-label={`${s.label} @autoworld_aw`}
                  className="flex h-11 w-11 items-center justify-center border border-white/20 transition-colors hover:bg-white hover:text-black"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
              <span className="ml-2 self-center font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                @autoworld_aw
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Brands</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-honda" to="/brands/honda" className="text-neutral-300 hover:text-white">Honda</Link></li>
              <li><Link data-testid="footer-link-proton" to="/brands/proton" className="text-neutral-300 hover:text-white">Proton</Link></li>
              <li><Link data-testid="footer-link-jaecoo" to="/brands/jaecoo" className="text-neutral-300 hover:text-white">Jaecoo &amp; Omoda</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Explore</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-models" to="/models" className="text-neutral-300 hover:text-white">All Models</Link></li>
              <li><Link data-testid="footer-link-offers" to="/offers" className="text-neutral-300 hover:text-white">This Month's Offers</Link></li>
              <li><Link data-testid="footer-link-bulk" to="/bulk" className="text-neutral-300 hover:text-white">Bulk Purchase</Link></li>
              <li><Link data-testid="footer-link-calculator" to="/calculator" className="text-neutral-300 hover:text-white">Loan Calculator</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Talk to us</div>
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="mt-5 flex items-center gap-2 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors hover:bg-white hover:text-black"
            >
              <WhatsAppIcon className="h-4 w-4" /> {WA_DISPLAY}
            </a>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              Mon–Sat 9–6 · Sun 10–5
            </p>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
            © 2026 AutoWorld · Malaysia
          </p>
        </div>
      </div>
    </footer>
  );
}
